import React, { useContext, useEffect } from "react";
import VtradingContext from "../context/vTrading/VTradingContext";
import ParameterContext from "../context/parameter/parameterContext";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { FiAlertTriangle } from "react-icons/fi";
import TradathonContext from "../context/tradathon/TradathonContext";
import { withRouter } from "react-router-dom";
const SellAlert = ({ orderid, type, location }) => {
  const {
    toggleVtradingAlertModal,
    setSellType,
    activePrice,
    cancelOrder,
    activeCrypto,
    placeMarketSellOrder,
    portId,
  } = useContext(VtradingContext);
  const { vtButton } = useContext(ParameterContext);
  const {
    deleteCoins,
    coinCSTAmount,
    tradathon_cancelOrder,
    tradathon_activePrice,
    tradathon_activeCrypto,
    activeRoom,
    tradathon_placeMarketSellOrder,
    tradathon_setSellType,
  } = useContext(TradathonContext);
  useEffect(() => {
    setSellType("sell");
    tradathon_setSellType("sell");
    //eslint-disable-next-line
  }, []);
  return vtButton === "openOrder" ? (
    <div className="Register">
      <div className="Login__container">
        <div style={{ textAlign: "right" }}>
          <IoIosCloseCircleOutline
            size={40}
            style={{ cursor: "pointer" }}
            onClick={toggleVtradingAlertModal}
          />
        </div>
        <div className="Register__content">
          <div className="SellAlert__icon">
            <FiAlertTriangle size={100} style={{ color: "#fff" }} />
          </div>
          <h2>Alert!</h2>
          <p>Are you sure you want to delete this order ?</p>
        </div>

        <div className="Register__social" style={{ marginTop: "10px" }}>
          <button
            className="Register__button"
            onClick={toggleVtradingAlertModal}
            style={{
              marginRight: "10px",
              width: "100px",
              borderRadius: "5px",
              background: "#EFF2F5",
              color: "#000",
            }}
          >
            CANCEL
          </button>
          <button
            className="Register__button"
            onClick={() => {
              if (location.pathname.split("/").includes("room")) {
                tradathon_cancelOrder(tradathon_activePrice.orderId);
                toggleVtradingAlertModal();
              } else {
                cancelOrder(activePrice.orderId);
                toggleVtradingAlertModal();
              }
            }}
            style={{
              marginRight: "10px",
              width: "100px",
              borderRadius: "5px",
            }}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  ) : location.pathname === "/tradathon/addcoins" ||
    location.pathname.split("/").includes("tradathon") ? (
    activeRoom && activeRoom.room.rstatus === 1 ? (
      <div className="Register">
        <div className="Login__container">
          <div style={{ textAlign: "right" }}>
            <IoIosCloseCircleOutline
              size={40}
              style={{ cursor: "pointer" }}
              onClick={toggleVtradingAlertModal}
            />
          </div>
          <div className="Register__content">
            <div className="SellAlert__icon">
              <FiAlertTriangle size={100} style={{ color: "#fff" }} />
            </div>
            <h2>Alert!</h2>
            <p>
              Are you sure you want to sell all your{" "}
              {` ${tradathon_activeCrypto.symbol}'s?`}
            </p>
          </div>

          <div className="Register__social" style={{ marginTop: "10px" }}>
            <button
              className="Register__button"
              onClick={toggleVtradingAlertModal}
              style={{
                marginRight: "10px",
                width: "100px",
                borderRadius: "5px",
                background: "#EFF2F5",
                color: "#000",
              }}
            >
              CANCEL
            </button>
            <button
              className="Register__button"
              onClick={() => {
                tradathon_placeMarketSellOrder(activePrice.amount);
                toggleVtradingAlertModal();
              }}
              style={{
                marginRight: "10px",
                width: "100px",
                borderRadius: "5px",
              }}
            >
              OK
            </button>
          </div>
        </div>
      </div>
    ) : (
      <div className="Register">
        <div className="Login__container">
          <div style={{ textAlign: "right" }}>
            <IoIosCloseCircleOutline
              size={40}
              style={{ cursor: "pointer" }}
              onClick={toggleVtradingAlertModal}
            />
          </div>
          <div className="Register__content">
            <div className="SellAlert__icon">
              <FiAlertTriangle size={100} style={{ color: "#fff" }} />
            </div>
            <h2>Alert!</h2>
            <p>Are you sure you want to delete?</p>
          </div>

          <div className="Register__social" style={{ marginTop: "10px" }}>
            <button
              className="Register__button"
              onClick={toggleVtradingAlertModal}
              style={{
                marginRight: "10px",
                width: "100px",
                borderRadius: "5px",
                background: "#EFF2F5",
                color: "#000",
              }}
            >
              CANCEL
            </button>
            <button
              className="Register__button"
              onClick={() => {
                deleteCoins(coinCSTAmount.coinId);
                toggleVtradingAlertModal();
              }}
              style={{
                marginRight: "10px",
                width: "100px",
                borderRadius: "5px",
              }}
            >
              OK
            </button>
          </div>
        </div>
      </div>
    )
  ) : (
    <div className="Register">
      <div className="Login__container">
        <div style={{ textAlign: "right" }}>
          <IoIosCloseCircleOutline
            size={40}
            style={{ cursor: "pointer" }}
            onClick={toggleVtradingAlertModal}
          />
        </div>
        <div className="Register__content">
          <div className="SellAlert__icon">
            <FiAlertTriangle size={100} style={{ color: "#fff" }} />
          </div>
          <h2>Alert!</h2>
          <p>
            Are you sure you want to sell all your{" "}
            {` ${activeCrypto.symbol}'s ?`}?
          </p>
        </div>

        <div className="Register__social" style={{ marginTop: "10px" }}>
          <button
            className="Register__button"
            onClick={toggleVtradingAlertModal}
            style={{
              marginRight: "10px",
              width: "100px",
              borderRadius: "5px",
              background: "#EFF2F5",
              color: "#000",
            }}
          >
            CANCEL
          </button>
          <button
            className="Register__button"
            onClick={() => {
              placeMarketSellOrder({
                symbol: activeCrypto.symbol,
                portId,
                type: "sell",
                amount: activePrice.amount,
              });
              toggleVtradingAlertModal();
            }}
            style={{
              marginRight: "10px",
              width: "100px",
              borderRadius: "5px",
            }}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default withRouter(SellAlert);
